import HeaderBrandLogo from '../../../../components/header-brand-logo/header-brand-logo';
import headerBrandLogo from './header-brand-logo';

export default headerBrandLogo(HeaderBrandLogo);
